export const queryKeys = {
  corporate: {
    memberships: () => ['corporate', 'memberships'] as const,
    dashboard: (slug: string, days: number) => ['corporate', slug, 'dashboard', days] as const,
    leaderboard: (slug: string, period: string) =>
      ['corporate', slug, 'leaderboard', period] as const,
    members: (slug: string, filters: Record<string, unknown>) =>
      ['corporate', slug, 'members', filters] as const,
    memberStats: (slug: string, userId: string) =>
      ['corporate', slug, 'member-stats', userId] as const,
    interCompany: (metric: string) => ['corporate', 'inter-leaderboard', metric] as const,
    domains: (slug: string) => ['corporate', slug, 'domains'] as const,
    levels: (slug: string) => ['corporate', slug, 'levels'] as const,
    designations: (slug: string) => ['corporate', slug, 'designations'] as const,
  },
  programs: {
    my: () => ['programs', 'my'] as const,
    available: () => ['programs', 'available'] as const,
    enrollments: () => ['programs', 'enrollments'] as const,
    detail: (id: string) => ['programs', id] as const,
    benefits: (id: string) => ['programs', id, 'benefits'] as const,
  },
  player: {
    profile: () => ['player', 'profile'] as const,
    rank: () => ['player', 'rank'] as const,
    carbon: () => ['player', 'carbon'] as const,
  },
  streaks: {
    all: () => ['streaks'] as const,
  },
  bloomIndex: {
    current: () => ['bloom-index'] as const,
  },
};
